Namespace 'Monitoring.Models.SocialContents.LinkedIn.Builders'

class Monitoring.Models.SocialContents.LinkedIn.Builders.LinkedInPostBuilder

  setText: (text) ->
    @text = text

  getText: ->
    @text

  setCreatedAt: (createdAt) ->
    @createdAt = createdAt

  getCreatedAt: ->
    @createdAt

  setContentId: (contentId) ->
    @contentId = contentId

  getContentId: ->
    @contentId

  setIsBrandContent: (isBrandContent) ->
    @isBrandContent = isBrandContent

  getIsBrandContent: ->
    @isBrandContent

  setContentURN: (contentURN) ->
    @contentURN = contentURN

  getContentURN: ->
    @contentURN

  setHasMedia: (hasMedia) ->
    @hasMedia = hasMedia

  getHasMedia: ->
    @hasMedia

  build: ->
    new Monitoring.Models.SocialContents.LinkedIn.LinkedInPost(@)
